import { CoherencePanel } from "@coherence-design-system/controls";
import { DefaultButton } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedItem, toggleAddItemPanel } from "../../reducers/diningReducer";
import { selectedItemSelector, stationSelector, togglePanelSelector } from "../../selectors/diningSelector";
import withAppInsights from "../AppInsights/AppInsights";
import AddItemForm from "./AddItemForm";

export const AddItemPanel: React.FunctionComponent = () => {
  const dispatch = useDispatch();
  const selectedItem = useSelector(selectedItemSelector);
  const isPanelOpen = useSelector(togglePanelSelector);
  const selectedStation = useSelector(stationSelector);

  const _togglePanel = () => {
    dispatch(toggleAddItemPanel());
  };
  const _handleAddNewItem = () => {
    if (selectedItem) {
      dispatch(setSelectedItem(undefined));
    }
    _togglePanel();
  };
  return (
    <>
      {selectedStation && <DefaultButton text={"Add new item"} onClick={_handleAddNewItem} primary={true} />}
      <CoherencePanel
        type={1}
        titleText={selectedItem ? "Edit" : "Add item"}
        isOpen={isPanelOpen}
        onDismiss={_togglePanel}
        hasCloseButton={true}
        closeButtonAriaLabel={"close"}
        isFooterAtBottom={false}
      >
        {/* @ts-ignore */}
        <AddItemForm closePanel={_togglePanel} />
      </CoherencePanel>
    </>
  );
};

export default withAppInsights(AddItemPanel);
